import { z } from 'zod';

/**
 * Region form validation, mirroring the Admin API (AdminRegionRequest):
 * names up to 100 characters, a code of letters, digits, hyphens and
 * underscores up to 50. No position: it changes only in the region order.
 * Input type === output type.
 */
export const regionSchema = z.object({
  name: z.string().trim().min(1, 'Name is required.').max(100, 'Must be 100 characters or fewer.'),
  arName: z
    .string()
    .trim()
    .min(1, 'Arabic name is required.')
    .max(100, 'Must be 100 characters or fewer.'),
  code: z
    .string()
    .trim()
    .min(1, 'Code is required.')
    .max(50, 'Must be 50 characters or fewer.')
    .regex(/^[A-Za-z0-9_-]+$/, 'Use letters, digits, hyphens and underscores only (e.g. US).'),
});

export type RegionFormValues = z.infer<typeof regionSchema>;
